import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { BulkDeleteJobUtility } from './BulkDeleteJobUtility';
import { DeleteJobUtility } from './DeleteJobUtility';

export const AdminUtilities = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Box>
        <Typography variant="h5" sx={{ mb: 2 }}>
          {t('administration.utilities.delete_job')}
        </Typography>
        <DeleteJobUtility />
      </Box>

      <Divider />

      <Box>
        <Typography variant="h5" sx={{ mb: 2 }}>
          {t('administration.utilities.bulk_delete_jobs')}
        </Typography>
        <BulkDeleteJobUtility />
      </Box>
    </Box>
  );
};
